import { Predicate } from "@utils/predicate";
import { alwaysFalse, alwaysTrue } from "@utils/utils";
import { Action } from "./action";
import { EventCallback } from "./step";

export interface StepOptionsInternal {
    /**
     * Determines whether the step is included in the wizard.
     * It is IMPORTANT that the isEnabledCallback's result can never depend on decisions in subsequent steps.
     * Otherwise the activeStep of the wizard will point to the incorrect step.
     */
    isEnabledCallback: Predicate;
    /**
     * Determines whether the step is in a valid state
     */
    isValidCallback: Predicate;
    /**
     * Used to determine whether the step is required
     */
    isRequiredCallback: Predicate;
    /**
     * The actions which can complete the wizard
     */
    actions: Action[];
    /**
     * Provides an info text
     */
    info: string;
    /**
     * Callback invoked during the next-operation of the wizard.
     * If false is returned the operation will be aborted.
     */
    onBeforeFinish: EventCallback;
};

export const defaultOptions: StepOptionsInternal = {
    isEnabledCallback: alwaysTrue,
    isValidCallback: alwaysTrue,
    isRequiredCallback: alwaysFalse,
    actions: [],
    info: "",
    onBeforeFinish: () => { return undefined; },
};
